import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface LeadProps extends HTMLAttributes<HTMLParagraphElement> {}

const Lead = forwardRef<HTMLParagraphElement, LeadProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn('text-xl text-muted-foreground', className)}
        {...props}
      >
        {children}
      </p>
    );
  }
);

Lead.displayName = 'Lead';

export { Lead };
